import React, {Component} from 'react';
import './InnerHeader.css';
import ChangePassword from '../ChangePassword/ChangePassword';
import { ToastContainer, toast } from 'react-toastify';
import { Link } from 'react-router-dom';


class InnerHeader extends Component {
  constructor(props) {
    super(props);
    this.defaultParams = {};
    this.state = {
        changePasswordModal: false,
        changedPassword: false,
    };
  }

  openModal = () => {
    this.setState({changePasswordModal : true, changedPassword: false});
  }
  closeModal = () => {
    this.setState({changePasswordModal : false});
  }
  componentWillReceiveProps(nextProps){
    if(nextProps.changePasswordResult){

        if( nextProps.changePasswordResult.status === 'success' && !this.state.changedPassword ){
            this.setState({changedPassword : true})
            this.closeModal();
            toast.success(nextProps.changePasswordResult.response);
        }
        if( nextProps.changePasswordResult.status === 'error' && !this.state.changedPassword ){
            this.setState({changedPassword : true})
            this.closeModal();
            toast.error(nextProps.changePasswordResult.response);
        }
    }

  }

  render() {
    const { me } = this.props;
    // console.log('ne', me)
    return (
        <div className="inner-header">
            <div className="inner-header-layout">
                <div className="container-fluid">
                    <div className='row'>
                        <div className="col-sm-12">
                            <Link  to='/toolkit' className={ this.props.location  !== 'toolkit' ? 'logo' : 'logo large' }></Link>

                            { this.props.location !== 'toolkit' &&
                                <div className='header-navigation-box'>
                                    <Link  to='/toolkit'>Home</Link>
                                </div>
                            }

                            <div className="header-content">
                                <h5>The Planning Tools</h5>
                                <p>{me && me.name ? me.name : ''}</p>
                                <div className='btn empty-btn default' onClick={this.openModal}> Change Password </div>
                                <div className='btn empty-btn default' onClick={this.props.onLogout}> Logout </div>

                                {this.state.changePasswordModal &&
                                    <ChangePassword
                                        closeModal={this.closeModal}
                                        changeUserPassword={this.props.changeUserPassword}

                                    />
                                }

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
  }
}

export default (InnerHeader);



// WEBPACK FOOTER //
// ./src/components/InnerHeader/InnerHeader.jsx